module.exports = __webpack_public_path__ + "media/images/flags/gq-c2cb1adba91b64af03bc41a5597899eb.svg";